import { render } from "./XImg.vue?vue&type=template&id=5d89ceca&scoped=true&ts=true"
import script from "./XImg.vue?vue&type=script&lang=ts"
export * from "./XImg.vue?vue&type=script&lang=ts"

import "./XImg.vue?vue&type=style&index=0&id=5d89ceca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d89ceca"]])

export default __exports__